import { useTranslation } from "react-i18next";
import styled from "styled-components";

const PlaceholderInfo = styled.div`
  width: 96%;
  margin: ${(props) => props.theme.space[3]} auto;
  border-radius: ${(props) => props.theme.space[2]};
  background: ${(props) => props.theme.colors.greyLight};
`;

const PlaceholderCopy = styled.h2`
  padding: 0 ${(props) => props.theme.space[2]};
  font-size: ${(props) => props.theme.fontSizes[3]};
  font-weight: 500;
  text-align: center;
`;

const PostSeasonAlert = () => {
  const { t } = useTranslation();
  return (
    <PlaceholderInfo>
      <PlaceholderCopy>
        {t("postSeason.seasonOver1", "The NBA Fantasy season is now over.")}
      </PlaceholderCopy>
      <PlaceholderCopy>
        {t(
          "postSeason.seasonOver2",
          "While you wait for next season, enjoy the NBA Playoffs and check out the links below.",
        )}
      </PlaceholderCopy>
    </PlaceholderInfo>
  );
};

export default PostSeasonAlert;
